import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AbstractBaseAddUpdateComponent } from 'src/app/core/component/abstract-base-add-update-component';
import { IBaseService } from 'src/app/core/service/ibase-service';
import { ModuleParamGlobConfigService } from 'src/app/core/service/moduleFieldConfig/module-param-glob-config.service';
import { PartyTypeConstant } from '../../party/modal/party-type-constant';
import { PartyTypeConstantModal } from '../../party/modal/party-type-constant-modal';
import { ModuleParamConfigModel } from '../modal/module-param-config-model';
import { PartyTypeModal } from '../modal/party-type-modal';
import { PartyTypeService } from '../service/party-type.service';

@Component({
  selector: 'app-party-type-add-update',
  templateUrl: './party-type-add-update.component.html',
  styleUrls: ['./party-type-add-update.component.css'],
})
export class PartyTypeAddUpdateComponent
  extends AbstractBaseAddUpdateComponent<PartyTypeModal>
  implements OnInit, AfterContentInit {
  private readonly MODULE_PARAM_CONFIG_KEY: string = 'partytype';

  public moduleParams: ModuleParamConfigModel;
  public formGroup: FormGroup;
  public data: PartyTypeModal;
  partyTypeList = PartyTypeConstant;
  public selectedPartyType: PartyTypeConstantModal;

  constructor(
    public service: PartyTypeService,
    public router: Router,
    public toastrService: ToastrService,
    private activeRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private moduleParamConfigGlob: ModuleParamGlobConfigService
  ) {
    super(toastrService, router);
  }

  ngOnInit() {
    this.init();
  }
  onCancel() {
    this.router.navigate(['/module/party/partyList']);
  }

  getService(): IBaseService<PartyTypeModal> {
    return this.service;
  }

  setData(data: PartyTypeModal) {
    this.data = data;
    if (this.isUpdateComponent) this.selectedPartyType = this.partyTypeList.find((ls) => ls.nameKey === this.data.key);
  }

  getData(): PartyTypeModal {
    return this.data;
  }

  public getModuleHomeUrl(): string {
    return '/module/party/partyList';
  }

  public getActiveRoute(): ActivatedRoute {
    return this.activeRoute;
  }

  public getNewModal(): PartyTypeModal {
    return new PartyTypeModal();
  }

  public getFormGroup(): FormGroup {
    return this.formGroup;
  }

  setValidation() {
    this.formGroup = this.formBuilder.group({
      name: ['', Validators.required],
      description: [
        '',
        this.moduleParamConfigGlob.isRequired(this.MODULE_PARAM_CONFIG_KEY, 'description') ? Validators.required : '',
      ],
      partyType: ['', Validators.required],
    });
  }

  public getId(): number {
    return this.data.id;
  }

  get f() {
    return this.formGroup.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.selectedPartyType) {
      this.data.key = this.selectedPartyType.nameKey;
    }
    if (this.formGroup.invalid) {
      this.toastrService.warning('Please Fill All The Mandatory Details !!', 'Error');
      return;
    }
    super.onSubmit();
  }

  ngAfterContentInit() {
    this.moduleParams = new ModuleParamConfigModel(this.moduleParamConfigGlob);
  }
}
